import React, {FC} from 'react';

import {useAppSelector} from '../../helpers/reduxHelpers';
import {SettingsResourcePagesEnum, SettingsVacationRespondersUrl} from '../../models/url/settingsUrlModel';
import {getVacationResponders} from '../../store/data/vacationResponders/vacationRespondersSelectors';
import {SettingsPanelId} from '../../store/panels/panelStateBase';
import {SettingsVacationRespondersForm} from './settingsVacationRespondersForm';
import {SettingsVacationRespondersList} from './settingsVacationRespondersList';

/*
 * Props.
 */

interface SettingsVacationRespondersContainerProps {
  panelId: SettingsPanelId;
  url: SettingsVacationRespondersUrl;
}

/*
 * Component.
 */

export const SettingsVacationRespondersContainer: FC<SettingsVacationRespondersContainerProps> = (props) => {
  const vacationResponders = useAppSelector(getVacationResponders);
  const {resourcePage, vacationResponderId} = props.url;

  const vacationResponder = vacationResponderId ? vacationResponders[vacationResponderId] : undefined;

  if (resourcePage === SettingsResourcePagesEnum.EDIT && vacationResponder) {
    return (
      <SettingsVacationRespondersForm
        panelId={props.panelId}
        vacationRespondersUrl={props.url}
        initialVacationResponder={vacationResponder}
      />
    );
  }

  if (resourcePage === SettingsResourcePagesEnum.NEW) {
    return (
      <SettingsVacationRespondersForm
        panelId={props.panelId}
        vacationRespondersUrl={props.url}
        initialVacationResponder={undefined}
      />
    );
  }

  return (
    <SettingsVacationRespondersList
      vacationResponders={vacationResponders}
      vacationRespondersUrl={props.url}
    />
  );
};
